/*global VeloxViewController, VeloxWebView, $*/

var welcomeController = new VeloxViewController({
    directory : "views/welcome",
    name: "welcome",
    //container: "welcome",
    route: "" //displayed by default
}) ;

module.exports = welcomeController ;


welcomeController.on("initView", function(){
    welcomeController.api.api.addOfflineStatusListener(function(isOffline){
        welcomeController.data.offline = isOffline ;
        welcomeController.view.render() ;
    }) ;
}) ;

var langs = [{name: "fr-FR", country: "fr"}, {name: "en-GB", country: "gb"}, {name: "es-ES", country: "es"}, {name: "de-DE", country: "de"}] ;
welcomeController.prepareDataOnEnter = function(data, callback){
    
    if(!this.api.currentUser || this.api.currentUser.login === "anonymous"){
        return callback(null, {factSheets: [], user: this.api.currentUser}) ;
    }
    this.api.api.multiread({
        diag_count: {searchFirst: {r_code: this.api.currentReseller}},
        reseller: {searchFirst: {r_code: this.api.currentReseller}},
        reseller_settings: {searchFirst: {r_code: this.api.currentReseller}},
        renewRequests: {table: "reseller_settings", search: {r_renew_status: "WAIT"}, joinFetch: [ {otherTable: "reseller"} ]},
        domain : {
            searchFirst: {}
        },
    }, function(err, reads){
        if(err){ return callback(err) ;}

        var countDiagTotal = 0;
        var countDiagToday = 0;
        var countDiagThisMonth = 0;
        if(reads.diag_count){
            countDiagTotal = reads.diag_count.count_total;
            countDiagToday = reads.diag_count.count_day;
            countDiagThisMonth = reads.diag_count.count_month;
        }
        // var monthStart = moment().startOf("month").format("YYYY-MM-DD HH:mm:ss.SSS");
        // var monthEnd = moment().endOf("month").format("YYYY-MM-DD HH:mm:ss.SSS");
        // var dayStart = moment().startOf("day").format("YYYY-MM-DD HH:mm:ss.SSS");
        // var dayEnd = moment().endOf("dat").format("YYYY-MM-DD HH:mm:ss.SSS");
        // reads.diag.forEach(function(diag){
        //     countDiagTotal++;
        //     if(diag.d_date>=dayStart && diag.d_date<=dayEnd){
        //         countDiagToday++;
        //     }
        //     if(diag.d_date>=monthStart && diag.d_date<=monthEnd){
        //         countDiagThisMonth++;
        //     }
        // }) ;

        var currentLang = VeloxWebView.i18n.getLang() ;
        langs.forEach(function(l){
            l.selected = (l.name.indexOf(currentLang) === 0) ;
        }) ;

        var renewByLang = {
            "fr-FR": {count: 0, country: "fr", lang: "fr-FR"}, 
            // "de-DE": {count: 0, country: "de", lang: "de-DE"}, 
            // "en-US": {count: 0, country: "gb", lang: "en-US"}, 
            // "es-ES": {count: 0, country: "es", lang: "es-ES"}
        } ;
        reads.renewRequests.filter(function(r){ return r.reseller ; }).forEach(function(r){
            renewByLang[r.reseller.r_lang].count ++ ;
        }) ;

        var renews = Object.keys(renewByLang).sort().map(function(l){ return renewByLang[l] ;}) ;

        return callback(null, {
            device: process.env.DEVICE,
            langs: langs,
            offline: this.api.api.isOffline(),
            domain: reads.domain,
            reseller: reads.reseller,
            reseller_settings: reads.reseller_settings||{},
            renews: renews,
            user: this.api.currentUser,
            licenseErr: this.api.licenseErr,
            licenseWarn: this.api.licenseWarn,
            countDiagTotal: countDiagTotal,
            countDiagToday: countDiagToday,
            countDiagThisMonth: countDiagThisMonth,
            serverUrl : this.api.options.serverUrl
        }) ;
    }.bind(this));
} ;

welcomeController.onLang = function(ev){
    var lang = ev.data.data.name ;
    this.view.longTask(function(done){
        this.api.api.velox_user.update({uid: this.api.currentUser.uid, lang: lang}, function(err){
            if(err){ return done(err) ;}

            VeloxWebView.i18n.setLang(lang) ;
            this.refresh() ;
            done() ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;


welcomeController.onLogout = function(){
    this.view.longTask(function(done){
        this.api.logout(function(err){
            if(err){ return done(err);}
            this.navigate("/") ;
            window.location.reload() ;
            done() ;
        }.bind(this)) ;
    }.bind(this));
} ;


welcomeController.onRenewLicenseErr = welcomeController.onRenewLicense = function(){

    var viewRenew = new VeloxWebView("views/welcome", "popupRenew") ;
    viewRenew.openInPopup({
        size:"medium",
        title: " "
    })  ;

    viewRenew.on("legals",function(){
        this.navigate("~legals") ;
    }.bind(this)) ;
    viewRenew.on("renew",function(){
        viewRenew.checkForm(viewRenew.EL.formRenew, [],function(err, checkOk){
            if(err){ return viewRenew.error(err) ;}
            if(!checkOk){
                return;
            }
            var message = viewRenew.getData().r_renew_message ;
            this.view.longTask(function(done){
                this.api.api.transactionalChangesNoCache([ //use no cache to force no sync reseller to save on server
                    {
                        table: "reseller_settings",
                        record: {
                            r_code: this.api.currentReseller, 
                            r_renew_status: 'WAIT', 
                            r_renew_date: new Date(),
                            r_renew_message: message
                        }
                    }
                ], function(err){
                    if(err){ return done(err) ;}
                    done() ;
                    this.view.info(VeloxWebView.tr("welcome.renewSaved"), function(){
                        this.refresh() ;
                        viewRenew.close() ;
                    }.bind(this)) ;
                }.bind(this)) ;
            }.bind(this)) ;
        }.bind(this));
    }.bind(this)) ;
} ;

welcomeController.onDisplayed = function(ev){
    //check WLC version on startup
    if(window.native && window.native.spinlab){
        window.native.spinlab.checkWlc(function(err){
            if(err){
                var message = err;
                if(err === "MISSING_WLC"){
                    message = VeloxWebView.tr("diag.shouldInstallWlc") ;
                } else if(err === "SHOULD_UPDATE_WLC"){
                    message = VeloxWebView.tr("diag.shouldUpdateWlc") ;
                }
                return this.view.error(message, function(){
                    window.native.spinlab.install() ;
                }) ;
            }
        }.bind(this)) ;
    }
    if(this.data && this.data.reseller_settings && this.data.reseller_settings.r_renew_status === 'ACCEPT'){
        VeloxWebView.info(VeloxWebView.tr("welcome.licenseRenewAccepted"), function(){
            this.view.longTask(function(done){
                this.api.api.transactionalChangesNoCache([
                    {
                        table: "reseller_settings",
                        record: {
                            r_code: this.api.currentReseller, 
                            r_renew_status: 'ACC_DONE', 
                        }
                    }
                ], function(err){
                    if(err){ return done(err) ;}
                    done() ;
                    this.refresh() ;
                }.bind(this)) ;
            }.bind(this)) ;
        }.bind(this)) ;
    } else if(this.data && this.data.reseller_settings && this.data.reseller_settings.r_renew_status === 'REFUSED'){
        VeloxWebView.error(VeloxWebView.tr("welcome.licenseRenewRefused"), function(){
            this.view.longTask(function(done){
                this.api.api.transactionalChangesNoCache([
                    {
                        table: "reseller_settings",
                        record: {
                            r_code: this.api.currentReseller, 
                            r_renew_status: 'REF_DONE', 
                        }
                    }
                ], function(err){
                    if(err){ return done(err) ;}
                    done() ;
                    this.refresh() ;
                }.bind(this)) ;
            }.bind(this)) ;
        }.bind(this)) ;
    } 
} ;

welcomeController.onChangePassword = function(){
    this.view.longTask(function(done){
        var viewChange = new VeloxWebView("views/main", "changePassword") ;
        viewChange.openInPopup({
            title: VeloxWebView.tr("main.changePassword")
        }, function(){
            done() ;
        }.bind(this))  ;
        viewChange.on("cancel",function(ev){
            viewChange.close() ;
        });
        viewChange.on("validate",function(ev){
            var data = viewChange.getData() ;
            this.api.changeUserPassword(data.passwordOld, data.passwordNew, function(err, success){
                if(err){ return done(err);}
                if(!success){
                    return done(VeloxWebView.tr("main.wrongPassword")) ;
                }
                viewChange.close() ;
                VeloxWebView.info(VeloxWebView.tr("main.changePasswordSuccess"), done) ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

welcomeController.onRenewRequest = function(ev){
    var lang = ev.data.data.lang ;
    this.navigate("renew", lang) ;
} ;

welcomeController.on("initView", function(){
    welcomeController.appController.on("routeChanged", function(ev){
        if(ev.data.removedRoutes.length > 0 && ev.data.removedRoutes[0].route === "renew"){
            welcomeController.refresh() ;
        }
    }) ;
}) ;


welcomeController.onNewDiag = welcomeController.onNewDiag2 = function(){
    if(this.api.licenseErr){
        return VeloxWebView.error(VeloxWebView.tr("mustHaveLicense")) ;
    }
    this.navigate("/diag/form") ;
} ;

welcomeController.on("unstack", function(){
    welcomeController.refresh();
});

welcomeController.on("stack", function(){
    var notifs = document.querySelectorAll('[data-notify="container"]') ;
    for(var i=0; i<notifs.length; i++){
        notifs[i].parentElement.removeChild(notifs[i]) ;
    }
}) ;